/**
 * Superadmin auth store — session-based login via /admin/login.
 */
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { apiClient, fetchCsrfCookie } from '@/services/apiClient.js'

export const useSaAuthStore = defineStore('saAuth', () => {
  const user = ref(null)
  const loading = ref(false)
  const error = ref(null)

  const isAuthenticated = computed(() => !!user.value)

  async function login(email, password) {
    loading.value = true
    error.value = null
    try {
      await fetchCsrfCookie()  // errors are swallowed inside fetchCsrfCookie now
      const data = await apiClient.post('/admin/login', { email, password })
      user.value = data.user
      return data
    } catch (e) {
      error.value = e.status === 422 ? e.errors : e.message
      throw e
    } finally {
      loading.value = false
    }
  }

  async function logout() {
    try {
      await apiClient.post('/admin/logout')
    } finally {
      user.value = null
    }
  }

  async function fetchUser() {
    try {
      const data = await apiClient.get('/admin/profile')
      user.value = data.user || data
    } catch {
      user.value = null
    }
  }

  return { user, loading, error, isAuthenticated, login, logout, fetchUser }
})
